import it from "./it";
import en from "./en";

// This object's keys must be an ISO language code (ex: it, it-IT, en-US)
const availableLocalisations = {
    en,
    it,
};

const getUserLocale = () => "IT";

/**
 * Given the user's locale, returns the appropriate translated messages.
 * If the provided locale has no matching translations, defaults to italian.
 * @param {string} locale The user's locale expressed as an ISO language code (ex: it, it-IT, en-US)
 */
function getMessagesFromLocale(locale = getUserLocale()) {
    if (locale) {
        const availableLocaleKeys = Object.keys(availableLocalisations);
        if (availableLocaleKeys.includes(locale)) {
            return convertMessages(availableLocalisations[locale]);
        } else if (availableLocaleKeys.includes(locale.split("-")[0])) {
            return convertMessages(
                availableLocalisations[locale.split("-")[0]],
            );
        }
    }

    return convertMessages(availableLocalisations["it"]);
}

function clearTmpKey(tmpKey) {
    let value = "";
    let cn = 0;
    tmpKey.split(".").map((val) => {
        cn++;
        if (cn < tmpKey.split(".").length) {
            value = `${value}${value.length > 0 ? "." : ""}${val}`;
        }
        return value;
    });
    return value;
}

function convertMessages(messages, newMessages = {}, tmpKey = "") {
    for (let item in messages) {
        if (typeof messages[item] === "object") {
            newMessages = convertMessages(
                messages[item],
                newMessages,
                (tmpKey = `${tmpKey}${tmpKey.length > 0 ? "." : ""}${item}`),
            );
            tmpKey = clearTmpKey(tmpKey);
        } else {
            newMessages[`${tmpKey}${tmpKey.length > 0 ? "." : ""}${item}`] =
                messages[item];
        }
    }
    return newMessages;
}

const translateMessage = (key) => getMessagesFromLocale()[key] || key;
const translateMessageWithParams = (key, values) => {
    let msg = getMessagesFromLocale()[key] || key;

    Object.keys(values).forEach((valueKey) => {
        msg = msg.replace(`{${valueKey}}`, values[valueKey]);
    });

    return msg;
};

export { getMessagesFromLocale, translateMessage, translateMessageWithParams };
